/* global APP, interfaceConfig */
// @ts-ignore
import $ from 'jquery';
import { setDocumentEditingState } from '../../../react/features/etherpad/actions';
import { getSharedDocumentUrl } from '../../../react/features/etherpad/functions';
import { getToolboxHeight } from '../../../react/features/toolbox/functions.web';
import Filmstrip from '../videolayout/Filmstrip';
import LargeContainer from '../videolayout/LargeContainer';
import VideoLayout from '../videolayout/VideoLayout';
/**
 * Default Etherpad frame width.
 */
const DEFAULT_WIDTH = 640;
/**
 * Default Etherpad frame height.
 */
const DEFAULT_HEIGHT = 480;
const ETHERPAD_CONTAINER_TYPE = 'etherpad';
/**
 * Container for Etherpad iframe.
 */
class Etherpad extends LargeContainer {
    /**
     * Creates new Etherpad object
     */
    // @ts-ignore
    constructor(url) {
        super();
        const iframe = document.createElement('iframe');
        iframe.id = 'etherpadIFrame';
        iframe.src = url;
        // @ts-ignore
        iframe.style.border = 0;
        iframe.scrolling = 'no';
        // @ts-ignore
        iframe.width = DEFAULT_WIDTH;
        // @ts-ignore
        iframe.height = DEFAULT_HEIGHT;
        iframe.setAttribute('style', 'visibility: hidden;');
        // @ts-ignore
        this.container.appendChild(iframe);
        // @ts-ignore
        this.iframe = iframe;
    }
    /**
     *
     */
    get isOpen() {
        // @ts-ignore
        return Boolean(this.iframe);
    }
    /**
     *
     */
    get container() {
        return document.getElementById('etherpad');
    }
    /**
     *
     */
    // @ts-ignore
    resize(containerWidth, containerHeight) {
        let height, width;
        if (interfaceConfig.VERTICAL_FILMSTRIP) {
            height = containerHeight - getToolboxHeight();
            width = containerWidth - Filmstrip.getVerticalFilmstripWidth();
        }
        else {
            height = containerHeight - Filmstrip.getFilmstripHeight();
            width = containerWidth;
        }
        // @ts-ignore
        $(this.iframe)
            .width(width)
            .height(height);
    }
    /**
     *
     */
    // @ts-ignore
    show() {
        // @ts-ignore
        const $iframe = $(this.iframe);
        const $container = $(this.container);
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const self = this;
        return new Promise(resolve => {
            $iframe.fadeIn(300, () => {
                // @ts-ignore
                self.bodyBackground = document.body.style.background;
                document.body.style.background = '#eeeeee';
                $iframe.css({ visibility: 'visible' });
                $container.css({ zIndex: 2 });
                APP.store.dispatch(setDocumentEditingState(true));
                // @ts-ignore
                resolve();
            });
        });
    }
    /**
     *
     */
    // @ts-ignore
    hide() {
        // @ts-ignore
        const $iframe = $(this.iframe);
        const $container = $(this.container);
        // @ts-ignore
        document.body.style.background = this.bodyBackground;
        return new Promise(resolve => {
            $iframe.fadeOut(300, () => {
                $iframe.css({ visibility: 'hidden' });
                $container.css({ zIndex: 0 });
                APP.store.dispatch(setDocumentEditingState(false));
                // @ts-ignore
                resolve();
            });
        });
    }
    /**
     * @return {boolean} do not switch on dominant speaker event if on stage.
     */
    // @ts-ignore
    stayOnStage() {
        return true;
    }
}
/**
 * Manager of the Etherpad frame.
 */
export default class EtherpadManager {
    /**
     *
     */
    constructor() {
        // @ts-ignore
        this.etherpad = null;
    }
    /**
     *
     */
    get isOpen() {
        // @ts-ignore
        return Boolean(this.etherpad);
    }
    /**
     *
     */
    isVisible() {
        return VideoLayout.isLargeContainerTypeVisible(ETHERPAD_CONTAINER_TYPE);
    }
    /**
     * Create new Etherpad frame.
     */
    openEtherpad() {
        // @ts-ignore
        this.etherpad = new Etherpad(getSharedDocumentUrl(APP.store.getState));
        VideoLayout.addLargeVideoContainer(ETHERPAD_CONTAINER_TYPE, 
        // @ts-ignore
        this.etherpad);
    }
    /**
     * Toggle Etherpad frame visibility.
     * Open new Etherpad frame if there is no Etherpad frame yet.
     */
    toggleEtherpad() {
        if (!this.isOpen) {
            this.openEtherpad();
        }
        const isVisible = this.isVisible();
        VideoLayout.showLargeVideoContainer(ETHERPAD_CONTAINER_TYPE, !isVisible);
        APP.store.dispatch(setDocumentEditingState(!isVisible));
    }
}
